import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as api from "@/api/overseasChinese/overseasChinese";
export default {
  name: "classRoomTimetable",
  data: function data() {
    return {
      semesterList: [],
      searchObj: {
        semesterId: "",
        weekNo: 1,
        classroomId: ""
      },
      weekList: [],
      headerData: [],
      // 周一 - 周五处理数据
      listData: [],
      // 周一 - 周五处理数据
      sumHour: 0,
      keyword: "",
      LeftTableData: [],
      rightTableData: []
    };
  },
  mounted: function mounted() {
    this.initData(); // this.getLeftTableData()
  },
  watch: {
    listData: {
      handler: function handler(val) {
        if (val) {
          this.rightTableData = val;
        }
      },
      deep: true
    }
  },
  methods: {
    initData: function initData() {
      this.tableLoading = true;
      this.getSemesterData();
      this.getLeftTableData();
    },
    getSemesterData: function getSemesterData() {
      var _this = this;

      api.getSemesterSel().then(function (_ref) {
        var data = _ref.data;
        _this.semesterList = data.data;
        var arr = data.data.find(function (item) {
          return item.current == 1;
        }) || data.data[0]; // let arr = data.data.find((item) => item.current == 1) || data.data[7]

        _this.searchObj.semesterId = arr.id;

        _this.getSchoolWeek();
      });
    },
    handleCurrentLeftChange: function handleCurrentLeftChange(val) {
      if (val) {
        this.tableLoading = true;
        this.searchObj.classroomId = val.classroomId; // this.getSchoolWeek()

        this.getTableList();
      }
    },
    semesterClick: function semesterClick() {
      this.getSchoolWeek();
    },
    //获取左侧筛选列表
    getLeftTableData: function getLeftTableData() {
      var _this2 = this;

      var params = {
        keyword: this.keyword,
        size: 100000
      };
      api.getClassRoomList(params).then(function (_ref2) {
        var data = _ref2.data;

        if (data.code === 0) {
          _this2.LeftTableData = data.data.records;

          if (data.data.records.length > 0) {
            _this2.searchObj.classroomId = data.data.records[0].classroomId;
            var row = data.data.records[0];

            _this2.$refs.leftTable.setCurrentRow(row);
          }
        } else {
          _this2.$alert(data.msg, "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      });
    },
    //获取右侧列表
    getTableList: function getTableList() {
      var _this3 = this;

      var listData_new = JSON.parse(JSON.stringify(this.listData)); // api.getClassRoomKbInfo(this.searchObj).then(({data}) => {

      api.getClassRoomKbInfo_new(this.searchObj).then(function (_ref3) {
        var data = _ref3.data;
        _this3.rightTableData = [];

        if (data.code === 0 && data.data.length > 0) {
          var resList = data.data;
          listData_new.forEach(function (e) {
            for (var i = 0; i < resList.length; i++) {
              if (e.index === resList[i].index && e.timeType === resList[i].timeType) {
                var course = "week".concat(resList[i].day);
                e[course] = resList[i].courseName;
                e[course + "teacherNme"] = resList[i].teacherNme;
                e[course + "classroomName"] = resList[i].classroom;
                e["courseJcs" + (Number(resList[i].day) + 1)] = resList[i].courseJcs || "";
              }
            }
          });
          _this3.rightTableData = listData_new;
        } else if (data.data.length === 0) {
          _this3.rightTableData = _this3.listData;
        } else if (data.code === 1) {
          _this3.$alert(data.msg, "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      });
    },
    // 合并表格按照合并节次
    arraySpanMethod: function arraySpanMethod(_ref4) {
      var row = _ref4.row,
          column = _ref4.column,
          rowIndex = _ref4.rowIndex,
          columnIndex = _ref4.columnIndex;

      if (!columnIndex) {
        if (rowIndex === row.rowIndex) {
          return {
            rowspan: row.numCourse,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }

      if (columnIndex > 1) {
        if (row["courseJcs".concat(columnIndex)] > "1") {
          return {
            rowspan: row["courseJcs".concat(columnIndex)],
            colspan: 1
          };
        } else {
          // console.log(66,columnIndex);
          return {
            rowspan: 1,
            colspan: 1
          };
        }
      }
    },
    // 表头样式
    setHeaderStyle: function setHeaderStyle(_ref5) {
      var row = _ref5.row,
          column = _ref5.column,
          rowIndex = _ref5.rowIndex,
          columnIndex = _ref5.columnIndex;

      if (rowIndex === 0 && columnIndex === 0) {
        this.$nextTick(function () {
          if (document.getElementsByClassName(column.id).length !== 0) {
            document.getElementsByClassName(column.id)[0].setAttribute("rowSpan", 2);
            return false;
          }
        });
      }

      if (rowIndex === 1 && (columnIndex === 0 || columnIndex === 1)) {
        return {
          display: "none"
        };
      }
    },
    // 左边颜色
    rowNameClass: function rowNameClass(_ref6) {
      var row = _ref6.row,
          column = _ref6.column,
          rowIndex = _ref6.rowIndex,
          columnIndex = _ref6.columnIndex;

      if (columnIndex === 0 || columnIndex === 1) {
        if (row.timeType === "am") {
          return "shangWu";
        } else if (row.timeType === "pm") {
          return "xiaWu";
        } else if (row.timeType === "night") {
          return "wanShang";
        }

        if (row.timeType === "morning") {
          return "zaozixi";
        } else if (row.timeType === "noon") {
          return "zhongwu";
        } else if (row.timeType === "evening") {
          return "wanzixi";
        } else {
          return "";
        }
      }
    },
    formartDate: function formartDate(startTime, endTime) {
      return "".concat(startTime.substring(5), " ~ ").concat(endTime.substring(5));
    },
    // 获取周列表
    getSchoolWeek: function getSchoolWeek() {
      var _this4 = this;

      if (this.searchObj.semesterId) {
        var params = {
          semesterId: this.searchObj.semesterId
        };
        this.tableLoading = true;
        api.getWeekSel(params).then(function (_ref7) {
          var data = _ref7.data;

          if (data.code === 0) {
            _this4.weekList = data.data;
            _this4.searchObj.weekNo = data.data[0].weekNo;

            _this4.getHeaderNew(data.data[0].beginDate);
          } else {
            _this4.$alert(data.msg, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          }
        }).catch(function () {
          _this4.tableLoading = false;
        });
      }
    },
    selectWeek: function selectWeek(item) {
      this.searchObj.weekNo = item.weekNo;
      this.getTableList();
    },
    getHeaderNew: function getHeaderNew(time) {
      var _this5 = this;

      this.headerData = [];
      this.listData = [];
      this.sumHour = 0;
      var params = {
        semesterId: this.searchObj.semesterId,
        weekStartTime: time
      };
      api.getTimeTabWeek(params).then(function (_ref8) {
        var data = _ref8.data;

        if (data.code === 0) {
          var times = data.data.times;
          var infos = data.data.infos;
          var leftArr = [];
          var keysTime = Object.keys(times);
          var new_timeArr = []; // 处理按顺序储存

          var timeArrType = ["morning", "am", "noon", "pm", "night", "evening"];

          for (var i = 0; i < timeArrType.length; i++) {
            if (keysTime.indexOf(timeArrType[i]) > -1) {
              new_timeArr.push(timeArrType[i]);
            }
          }

          for (var _i = 0, _new_timeArr = new_timeArr; _i < _new_timeArr.length; _i++) {
            var item = _new_timeArr[_i];

            for (var j = 0; j < infos.length; j++) {
              if (item === infos[j].type) {
                var amObj = {
                  rowIndex: JSON.parse(JSON.stringify(_this5.sumHour)),
                  numlabel: "\u7B2C".concat(j + 1, "\u8282"),
                  time: _this5.handleLabel(item),
                  numCourse: times[item].length,
                  timeType: item,
                  endTime: infos[j].endTime,
                  index: infos[j].index,
                  startTime: infos[j].startTime,
                  type: item
                };
                leftArr.push(amObj);
              }
            }

            _this5.sumHour += times[item].length;
          }

          _this5.listData = leftArr; // 头部

          for (var _i2 = 0; _i2 < 7; _i2++) {
            var o = {
              label: _this5.handleLabel(_i2 + 1),
              id: "week".concat(_i2 + 1)
            };

            _this5.headerData.push(o);
          }
        } else {
          _this5.$alert(data.msg, "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      });
    },
    handleLabel: function handleLabel(num) {
      switch (num) {
        case 1:
          return "周一";

        case 2:
          return "周二";

        case 3:
          return "周三";

        case 4:
          return "周四";

        case 5:
          return "周五";

        case 6:
          return "周六";

        case 7:
          return "周日";

        case "morning":
          return "早自习";

        case "am":
          return "上午";

        case "noon":
          return "中午";

        case "pm":
          return "下午";

        case "night":
          return "晚上";

        case "evening":
          return "晚自习";

        default:
          return "";
      }
    }
  }
};